import React, {
    FC,
    useEffect,
    useState,
} from "react";
import {fetchGarageList} from "../../api/apiService";
import {GarageTable} from "./list/GarageTable";
import {IGarageList} from "../../interfaces/Interfaces";
import {GarageListColumns} from "./list/GarageListColumns";
import {
    ILocation,
    MapView,
} from "./MapView";
import {CircularProgress} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {RoutesPath} from "../../enums/RoutesPath";

export const MotoGarages: FC = () => {
    const [garageData, setGarageData] = useState<IGarageList[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [selected, setSelected] = useState<ILocation | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        fetchGarageList()
            .then((makerData) => {
                setGarageData(makerData);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
                setLoading(false);
            });
    }, []);

    const mapData = garageData.map((item) => ({
            latitude: item.latitude,
            longitude: item.longitude,
            name: item.name,
            address: item.address,
        }
    ));

    const handleDetailsClick = (id: string) => {
        const navigateToDetailsPath = `${RoutesPath.MOTO_GARAGES}/${id}`;
        navigate(navigateToDetailsPath);
    };

    if (loading) {
        return <CircularProgress sx={{display: "block", margin: "auto"}}/>;
    }

    return (
        <div style={{textAlign: "center", padding: "20px"}}>
            <MapView data={mapData} selected={selected}/>
            <GarageTable
                data={garageData}
                columns={GarageListColumns}
                onDetailsClick={handleDetailsClick}
                onRowClick={setSelected}
            />
        </div>
    );
};
